// extracted by mini-css-extract-plugin
export default {"vulnerabilities-list":"vulnerabilities-list--doJtd","current":"current--KYcrL","list-container":"list-container--tLnwK"};